import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ExtendedImage from "../../../../components/ImageViewer/ImageViewer";
import isImage from "../../../../utils/isImage";
import styled from "styled-components";
import { purpurColorPurple100, purpurColorRed600 } from "@purpurds/tokens/color/variables";
import Icon from "../../../../icons";
import { PDF } from "../../../../constants/iconNames";
const CommentContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 16px;

  @media (min-width: 750px) {
    flex: 1;
    padding: 0;
  }
`;
const CommentHeader = styled.div `
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  padding: 0 0 5px 16px;
`;
const CommentContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 16px;
  background-color: ${purpurColorPurple100};
  border-radius: 4px;
  font-weight: 300;
  font-size: 18px;

  @media (min-width: 750px) {
    height: 100%;
  }
`;
const CommentError = styled.div `
  margin-top: 24px;
  color: ${purpurColorRed600};
 `;
const AttachmentList = styled.div `
  padding-top: 5px;

  button {
    border: none;
    background: none;
    padding: 0;
    font-weight: 300;
  }

  img {
    object-fit: cover;
    width: 80px;
    height: 80px;
  }

  *:not(:last-child){
    margin-right: 20px;
  }
`;
const TextBox = ({ heading, text, attachments = { hasError: false, attachmentList: [] }, languageStrings, }) => {
    const [expanded, setIsExpanded] = useState(false);
    const [chosenImage, setChosenImage] = useState(0);
    const attachmentList = attachments.attachmentList.map((attachment, index) => {
        if (!isImage(attachment.href)) {
            const fileEnding = attachment.href
                .substring(attachment.href.lastIndexOf(".") + 1)
                .toUpperCase();
            const title = fileEnding.length > 4 ? languageStrings.DEFAULT_FILE_NAME : fileEnding;
            return (_jsx("a", { href: attachment.href, rel: "noopener noreferrer", target: "_blank", children: _jsx(Icon, { name: PDF, title: title }) }, attachment.href));
        }
        return (_jsx("button", { onClick: () => {
                setIsExpanded(true);
                setChosenImage(index);
            }, children: _jsx("img", { src: attachment.href, alt: "Vedlegg" }) }, attachment.href));
    });
    const imageFiles = attachments.attachmentList
        .map((image) => image.href)
        .filter((link) => isImage(link));
    return (_jsxs(CommentContainer, { children: [_jsx(CommentHeader, { children: heading }), _jsxs(CommentContent, { children: [text, attachments.hasError && (_jsx(CommentError, { children: languageStrings.ATTACHMENT_ERROR })), attachmentList.length > 0 && !attachments.hasError && (_jsx(AttachmentList, { children: attachmentList })), expanded && (_jsx(ExtendedImage, { expandedIndex: chosenImage, imagesFiles: imageFiles, toggleExpandImage: () => setIsExpanded(!expanded) }))] })] }));
};
export default TextBox;
